/**
 * Core: DOM Ready
 * -----------------------------------------------------------------------------
 * Scripts are loaded asynchronously so 'DOMContentLoaded' can fire before JS
 * has finished loading.
 *
 */

/**
 * Check loading state and run callback or add event listener.
 * @param {Function} callback - Callback function to execute.
 */
export default (callback) => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback)
    return
  }

  if (typeof callback !== 'function') {
    reportError('DOM ready callback is not a function')
    return
  }

  callback()
}
